<template>
  <transition name="nm-slide">
    <div v-if="alerts.length" class="nm-alert" role="alert" aria-live="assertive">
      <span class="nm-alert__icon"><i class="fas fa-comment-dots"></i></span>

      <span class="nm-alert__text">
        <b v-if="alerts.length === 1">برای یکی از تیکت‌های شما پیام جدیدی ثبت شده است.</b>
        <b v-else>برای {{ alerts.length }} تیکت شما پیام جدیدی ثبت شده است.</b>
      </span>

      <span class="nm-alert__links">
        <router-link
          v-for="a in alerts"
          :key="a.ticketId"
          :to="{ name: 'Ticket', params: { ticketId: a.ticketId } }"
          class="nm-alert__link"
          @click="dismiss(a.ticketId)"
        >
          مشاهده‌ی تیکت
          <button
            type="button"
            class="nm-alert__x"
            aria-label="بستن این هشدار"
            @click.prevent.stop="dismiss(a.ticketId)"
          >&times;</button>
        </router-link>
      </span>

      <button type="button" class="nm-alert__dismiss" @click="dismissAll">
        بستن همه
      </button>
    </div>
  </transition>
</template>

<script>
import {
  pulseState,
  dismissTicketAlert,
  dismissAllTicketAlerts,
} from "@/utils/ticketPulse";

export default {
  name: "NewMessageAlert",
  computed: {
    alerts() {
      return pulseState.alerts;
    },
  },
  methods: {
    dismiss(id) {
      dismissTicketAlert(id);
    },
    dismissAll() {
      dismissAllTicketAlerts();
    },
  },
};
</script>

<style scoped>
.nm-alert {
  position: sticky;
  top: 0;
  z-index: 1030;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: var(--bndbs-primary, #f35b21);
  color: #fff;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.18);
  font-size: 0.92rem;
}
.nm-alert__icon {
  font-size: 1.1rem;
  flex: 0 0 auto;
}
.nm-alert__text {
  flex: 1 1 auto;
}
.nm-alert__links {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.nm-alert__link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  text-decoration: none;
  font-weight: 600;
}
.nm-alert__link:hover {
  background: rgba(255, 255, 255, 0.3);
}
.nm-alert__x {
  border: none;
  background: transparent;
  color: #fff;
  font-size: 1.05rem;
  line-height: 1;
  cursor: pointer;
  padding: 0 2px;
}
.nm-alert__dismiss {
  flex: 0 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.6);
  background: transparent;
  color: #fff;
  border-radius: 6px;
  padding: 4px 12px;
  cursor: pointer;
}
.nm-alert__dismiss:hover {
  background: rgba(255, 255, 255, 0.15);
}

.nm-slide-enter-active,
.nm-slide-leave-active {
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.nm-slide-enter-from,
.nm-slide-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
